import React from 'react';
import { Link } from 'react-router-dom';

const posts = [
  {
    slug: 'multimodal-ai-for-gaming-and-human-performance',
    title: 'Multimodal AI for Gaming & Human Performance',
    date: '2026-03-19',
    tags: ['AI', 'Gaming', 'Healthcare', 'HRV'],
    excerpt: 'We wired up a gaming session with a chest-strap ECG, two wearables and full controller logging - then looked at what actually makes your heart rate spike. Spoiler: it\'s not kills.',
    cover: '/posts/images/multimodal-ai-for-gaming-and-human-performance/cover.jpg',
    gradient: 'linear-gradient(135deg, #667eea 0%, #06b6d4 100%)',
  },
];

function formatDate(iso) {
  return new Date(iso).toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function BlogPage() {
  return (
    <section id="blog" className="no-anim blog-listing-section">
      <div className="blog-listing-header">
        <h2>Insights & Blog</h2>
        <p>Writing from the Dabra team - on AI, healthcare, and the places they meet.</p>
      </div>

      <div className="blog-card-grid">
        {posts.map(post => (
          <Link to={`/blog/${post.slug}`} key={post.slug} className="blog-card">
            <div
              className="blog-card-cover"
              style={post.cover ? {} : { background: post.gradient }}
            >
              {post.cover && (
                <img
                  src={post.cover}
                  alt={post.title}
                  className="blog-card-cover-img"
                />
              )}
              <div className="blog-card-tags">
                {post.tags.map(t => <span key={t} className="blog-tag">{t}</span>)}
              </div>
            </div>
            <div className="blog-card-body">
              <h3 className="blog-card-title">{post.title}</h3>
              <div className="blog-card-meta">{formatDate(post.date)} · Dabra team</div>
              <p className="blog-card-excerpt">{post.excerpt}</p>
              <span className="blog-card-read">Read →</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
